import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/**
 * Hook que dispara page_view automaticamente em cada navegação SPA.
 * Deve ser chamado dentro do BrowserRouter.
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Pequeno delay para garantir que o document.title já foi atualizado pelo SEOHead
    const timeout = setTimeout(() => {
      trackPageView(document.title, location.pathname + location.search);
    }, 100);
    return () => clearTimeout(timeout);
  }, [location.pathname, location.search]);
}
